import { useMemo } from "react";
import { useQueries } from "react-query";

import { useAxios } from "../../hooks/useAxios";
import {
  IUseFetchAverageUserAccuraciesResult,
  fetchAverageUserAccuraciesQuery,
} from "./useFetchAverageUserAccuracies";

export interface IUseFetchAverageUserAccuraciesBulkProps {
  classroom_ids?: Array<string>;
  refetchOnWindowFocus?: boolean;
}

export interface IUseFetchAverageUserAccuraciesBulkResult {
  isLoading: boolean;
  accuracyData: {
    [classroom_id: string]: IUseFetchAverageUserAccuraciesResult;
  };
}

const useFetchAverageUserAccuraciesBulk = ({
  classroom_ids = [],
  refetchOnWindowFocus = true,
}: IUseFetchAverageUserAccuraciesBulkProps): IUseFetchAverageUserAccuraciesBulkResult => {
  const axios = useAxios();

  const accuracyQueries = useQueries(
    classroom_ids.map((classroom_id) => {
      const params = {
        classroom_id,
      };

      return {
        queryKey: ["user-accuracies", params],
        queryFn: fetchAverageUserAccuraciesQuery(axios, params),
        refetchOnWindowFocus,
      };
    })
  );

  const accuracyData = useMemo(() => {
    const accuracyByClassroom: {
      [key: string]: IUseFetchAverageUserAccuraciesResult;
    } = {};

    accuracyQueries.forEach((q, i) => {
      accuracyByClassroom[classroom_ids[i]] = q.data || {
        average_user_accuracies: [],
      };
    });

    return accuracyByClassroom;
  }, [accuracyQueries, classroom_ids]);

  return {
    isLoading: accuracyQueries.some((q) => q.isLoading),
    accuracyData,
  };
};

export default useFetchAverageUserAccuraciesBulk;
